import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "Service/api/api";
import {
  INotificationsParams,
  NOTIFICATIONS_PRIORITY,
} from "Shared/Types/notifications";
import {
  hideAllNotificationsState,
  decreaseNotificationCount,
  deleteAllNotificationsState,
} from "./slice";
import { IReducerWithCallback } from "Shared/Types/shared";

const getNotifications = createAsyncThunk(
  "notifications/getNotifications",
  async (params: INotificationsParams | null) => {
    try {
      const response = await api.notifications.getNotificationsList(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

const getNotificationsMore = createAsyncThunk(
  "notifications/getNotificationsMore",
  async (params: INotificationsParams | null) => {
    try {
      const response = await api.notifications.getNotificationsList(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

const checkNotificationsCount = createAsyncThunk(
  "notifications/checkNotificationsCount",
  async (params: INotificationsParams | null) => {
    try {
      const response = await api.notifications.getNotificationsList({
        ...(params || {}),
        is_read: false,
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

const checkUrgentNotifications = createAsyncThunk(
  "notifications/checkUrgentNotifications",
  async (params: INotificationsParams | null) => {
    try {
      const response = await api.notifications.getNotificationsList({
        ...(params || {}),
        priority: NOTIFICATIONS_PRIORITY.URGENT,
        is_read: false,
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

const markAsRead = createAsyncThunk(
  "notifications/markAsRead",
  async ({ data, onSuccess, onError }: IReducerWithCallback<string>, state) => {
    try {
      await api.notifications.markAsRead(data);
      if (onSuccess) onSuccess();
      state.dispatch(decreaseNotificationCount());
    } catch (error) {
      if (onError) onError();
      console.error(error);
      throw error;
    }
  }
);

const markAllAsRead = createAsyncThunk(
  "notifications/markAllAsRead",
  async (_p, state) => {
    try {
      await api.notifications.markAllReadNotifications();
      state.dispatch(hideAllNotificationsState());
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

const deleteAllNotifications = createAsyncThunk(
  "notifications/deleteAllNotifications",
  async (_p, state) => {
    try {
      await api.notifications.hideAllNotifications();
      state.dispatch(deleteAllNotificationsState());
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export {
  getNotifications,
  checkNotificationsCount,
  checkUrgentNotifications,
  markAsRead,
  markAllAsRead,
  deleteAllNotifications,
  getNotificationsMore,
};
